import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { createElement } from "commonAssets/lib/createElement";
import {
    FormFields,
    FormFieldsLabel,
} from "commonAssets/components/FormBase/FormFields";
import { modal } from "commonAssets/lib/modal";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { validateField } from "commonAssets/lib/validateField";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { localDatetime } from "commonAssets/lib/localDatetime";

import { i18n, reCAPTCHAv3, loading, outputDiv } from "commonAssets/js/constants";
import { appPayMethod } from "commonAssets/js/constants";
import { dstProcess } from "commonAssets/components/FormBase/DigitalDisbursements";

export class CustomSubmitClaim extends SubmitClaim {
    // Deficiency portal: suppress default deadline UI
    claim_deadline() {
        return document.createDocumentFragment();
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);

                const zero_zero_id =
                    document.getElementById("zero_zero_id");
                const confirmation_code =
                    document.getElementById("confirmation_code");
                const skip_guard =
                    document.getElementById("skip-guard");

                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener("change", validateField);
                });

                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        document.getElementById("guard").remove();
                        container.appendChild(
                            this.claim_form(form, datetime)
                        );
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);
                        this.init_claim_fields(
                            this.claim,
                            form,
                            claim_deadline
                        );
                    });
                }

                document
                    .getElementById("submit-guard")
                    .addEventListener("click", () => {
                        document
                            .getElementById("guard")
                            .classList.add("was-validated");
                    });

                document
                    .getElementById("guard")
                    .addEventListener("submit", (e) => {
                        e.preventDefault();

                        let valid = true;
                        const member = {
                            domain: this.claim.data.domain,
                            zero_zero_id:
                                zero_zero_id.value.toUpperCase(),
                            confirmation_code:
                                confirmation_code.value,
                        };

                        clearMessage();

                        [zero_zero_id, confirmation_code].forEach(
                            function (input) {
                                valid =
                                    validateField(input) && valid;
                            }
                        );
                        if (!valid) return;

                        loadingGif(loading, "show");

                        this.claim.api
                            .classMemberPost({}, member)
                            .then((result) => {
                                if (result.data.error) {
                                    toggleFieldError(
                                        zero_zero_id,
                                        true,
                                        ""
                                    );
                                    toggleFieldError(
                                        confirmation_code,
                                        true,
                                        ""
                                    );
                                    this.errorHandler.log_exception(
                                        new Error(
                                            "Error loading class member",
                                            { cause: result }
                                        )
                                    );
                                    this.errorHandler.display_modal(
                                        result
                                    );
                                    return;
                                }

                                // START DEFICIENCY
                                let cmLabel = false;
                                let cmActive = false;
                                let cmCanEdit = false;

                                let ClassMemberStatus = Boolean(
                                    result.data.claim_id
                                )
                                    ? result.data.class_member
                                          .cm_data
                                          ?.ClassMemberStatus
                                    : result.data.cm_data
                                          ?.ClassMemberStatus;

                                if (
                                    !Array.isArray(
                                        ClassMemberStatus
                                    )
                                ) {
                                    modal(
                                        i18n.getTranslation(
                                            "error"
                                        ),
                                        "The deadline for filing a claim has passed."
                                    );
                                    loadingGif(
                                        loading,
                                        "hide",
                                        250
                                    );
                                    return;
                                }

                                for (const status of ClassMemberStatus) {
                                    if (
                                        status.Label !==
                                        "Deficient"
                                    )
                                        continue;

                                    if (status.Deadline) {
                                        const deadlineDate =
                                            new Date(
                                                status.Deadline
                                            );
                                        if (
                                            new Date() >
                                            deadlineDate
                                        ) {
                                            modal(
                                                i18n.getTranslation(
                                                    "error"
                                                ),
                                                "The deadline to fix your claim has passed."
                                            );
                                            loadingGif(
                                                loading,
                                                "hide",
                                                250
                                            );
                                            return;
                                        }
                                    }

                                    cmLabel = true;
                                    cmActive = Boolean(
                                        status.Active
                                    );
                                    cmCanEdit = Boolean(
                                        status.CanEdit
                                    );
                                    break;
                                }

                                if (
                                    !cmLabel ||
                                    !cmActive ||
                                    !cmCanEdit
                                ) {
                                    modal(
                                        i18n.getTranslation(
                                            "error"
                                        ),
                                        "This portal is not available for claim edits."
                                    );
                                    loadingGif(
                                        loading,
                                        "hide",
                                        250
                                    );
                                    return;
                                }
                                // END DEFICIENCY

                                this.claim.data.zero_zero_id =
                                    member.zero_zero_id;
                                this.claim.data.confirmation_code =
                                    member.confirmation_code;

                                const environment =
                                    this.claim.data.domain.split(
                                        "."
                                    )[0];

                                if (result.data.claim_id) {
                                    this.claim.data.claim_id =
                                        result.data.claim_id;
                                    this.claim.class_member =
                                        result.data;
                                    if (environment !== "local") {
                                        this.send_otp(
                                            form,
                                            container,
                                            result.data,
                                            claim_deadline
                                        );
                                        return;
                                    }
                                }

                                this.populate_claim_form(
                                    form,
                                    container,
                                    result.data,
                                    claim_deadline
                                );
                            })
                            .catch((error) => {
                                this.errorHandler.log_exception(
                                    new Error(
                                        "Error loading class member",
                                        { cause: error }
                                    )
                                );
                                this.errorHandler.display_modal(
                                    error
                                );
                            });
                    });

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", {
                        cause: error,
                    })
                );
                this.errorHandler.display(error);
            });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        super.populate_claim_form(form, container, class_member, claim_deadline);
        document.getElementById("claimFormDeadline")?.remove();
    }

    process_claim(e, claim) {
        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess === null
        ) {
            claim = dstProcess(this.claim);
        } else if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess !== null
        ) {
            claim = this.customDstProcess(this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise
                .execute(reCAPTCHAv3, { action: "submit" })
                .then((token) => {
                    claim.data.token = token;
                    this.post_claim(claim, s3env);
                });
        } else if (claim.flags.ineligible) {
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                "You are not eligible to submit a claim."
            );
        } else {
            document.getElementById("submit-claim").disabled = false;

            // Build custom error message with documentation requirements
            let customErrors = "";
            const requirements = [
                claim.flags.hasOrdinaryLosses &&
                    "• You must submit supporting documentation for your Ordinary Losses",
                claim.flags.hasExtraordinaryLosses &&
                    "• You must submit supporting documentation for your Extraordinary Losses",
                claim.flags.requiresCaliforniaResidencyDoc &&
                    "• You must submit supporting documentation proving residency in California before August 2022",
            ].filter(Boolean);
            if (requirements.length > 0) {
                customErrors =
                    "<br><br><strong> Documentation Requirements:</strong><br>" +
                    requirements.join("<br>");
            }

            const documentationErrors =
                claim.uploads.length === 0 ? customErrors : "";
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_form_errors") + documentationErrors
            );
        }
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "transactions",
            },
            [
                createElement(
                    "div",
                    {
                        class: "h3 mb-3 formTitle",
                    },
                    [],
                    params.form_options.transactions.title
                ),
                createElement(
                    "div",
                    {
                        class: "mb-3 formBody",
                    },
                    [],
                    params.form_options.transactions.body
                ),
            ]
        );

        // For Each Transaction Table
        const claimTransactions = params.claim_transactions;
        let tableID = 0;
        claimTransactions.forEach((table) => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", {
                class: "table-responsive mb-3",
                id: "table_responsive_" + tableID,
            });

            // <table class="table transactions"></table>
            const tableTransaction = createElement(
                "table",
                {
                    class: "table table-hover transactions caption-top",
                    id: "transactions_" + tableID,
                    "data-table-name": table.name,
                    "data-table-id": tableID,
                },
                [
                    createElement(
                        "caption",
                        { class: "text-dark bg-transparent" },
                        [],
                        "<strong>" +
                            table.name +
                            "</strong> &mdash; " +
                            table.description
                    ),
                ]
            );
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", {
                class: "table-dark text-light",
            });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach((col) => {
                const column = createElement(
                    "th",
                    { scope: "col" },
                    [],
                    col.title
                );
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement(
                        "span",
                        {
                            class: "d-block fw-normal",
                            style: "font-size:16px;",
                        },
                        [],
                        col.body
                    );
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            const countRow = 0;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const addRow = createElement(
                "div",
                {
                    class: "text-center",
                },
                [
                    createElement(
                        "a",
                        {
                            class: "btn btn-primary m-1",
                            id: "add_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label":
                                i18n.getTranslation("transaction_add_row") +
                                table.name,
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${table.name}`
                    ),
                    createElement(
                        "a",
                        {
                            // ada compliance updates - added
                            class: "btn btn-danger m-1 disabled", // default to disabled
                            id: "remove_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label": i18n.getTranslation(
                                "transaction_delete_row"
                            ),
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation("transaction_delete_row")}`
                    ),
                ]
            );

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(
                addRow,
                table,
                tableTBODY,
                tableID,
                countRow
            );

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(addRow);
        });

        return fieldset;
    }
    claim_transaction_row_buttons_events(
        addRow,
        table,
        tableTBODY,
        tableID,
        countRow
    ) {
        // Add row for every click
        addRow.firstChild.addEventListener("click", (event) => {
            countRow++;
            const tableId = event.target.attributes.tableID.value;
            this.claim_transaction_row(table, tableTBODY, tableId, countRow);
            this.toggleRemoveBtnDisabledOnCount(countRow, tableId);
        });
        // Remove row for every click
        addRow.lastChild.addEventListener("click", (event) => {
            countRow--;
            const tableId = event.target.attributes.tableID.value;
            const table = document.querySelector(`#transactions_${tableId}`);
            const tableTBody = table.querySelector("tbody");
            tableTBody.removeChild(tableTBody.lastChild);
            this.toggleRemoveBtnDisabledOnCount(countRow, tableId);
        });
    }

    toggleRemoveBtnDisabledOnCount(countRow, tableId) {
        if (countRow !== 0) {
            document
                .querySelector(`#remove_transactions_${tableId}`)
                .classList.remove("disabled");
        } else {
            document
                .querySelector(`#remove_transactions_${tableId}`)
                .classList.add("disabled");
        }
    }

    /**
     * Adds a new transaction row to the given table.
     * @param {HTMLTableElement} table - The table to add the row to.
     * @param {HTMLTableSectionElement} tableTBODY - The table body to add the row to.
     * @param {string} tableID - The ID of the table.
     * @param {number} countRow - The count of the row.
     * @returns {Object} An object containing the table body and the fields row.
     */
    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        if (countRow === 0) {
            return { tableTBODY, fieldsRow: null };
        }
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);

        let fieldID = 0;
        table.fields.forEach((field) => {
            fieldID++;
            const td = createElement("td", {
                class: "transaction " + field.name,
            });
            const element = createElement("div");
            const validation = field.validation;

            const formInput = FormFields(
                field,
                "",
                fieldID,
                element,
                validation,
                fieldsRow
            );

            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);

            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            const allRowsCount = document
                .getElementById("transactions")
                .querySelectorAll(".transaction-row").length;

            // set item-id attribute
            formInput.setAttribute("item-id", allRowsCount);

            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }
}
